import { types as t, getRoot } from 'mobx-state-tree'
import subsectorsDataset from '../../../datasets/global-CIRCLES-2020-emissions-sector-subsector.csv'
import { SubsectorDatum } from '../types'
import { sortBy } from 'lodash-es'
import { interpolateRgb } from 'd3'
import { Challenge, PALETTE_GRADIENT_TO_WHITE } from '../../../lib/constants'
import { NAVIGATION_TABS, NavigationTabName } from '../constants'

export const CirclesModel = t
  .model('CirclesModel', {
    debug: false,
    selectedNavTab: t.optional(t.enumeration(NAVIGATION_TABS.map((t) => t.name)), 'challenges'),
    challenge: '',
  })
  .views((self) => ({
    get root() {
      return getRoot(self)
    },
  }))
  .views((self) => ({
    get activeSubsectors() {
      // TODO: better mapping between self.challenge and the value in the dataset
      const subsectors = (subsectorsDataset as SubsectorDatum[]).filter(
        (d) => d.sector === self.challenge
      )
      const [color1, color2] = PALETTE_GRADIENT_TO_WHITE[self.challenge]
      return sortBy(subsectors, 'emission_mmt_co2').map((d, i) => ({
        ...d,
        color: interpolateRgb(color2, color1)(i / subsectors.length),
      }))
    },
  }))
  .actions((self) => ({
    setSelectedNavTab(selectedNavTab: NavigationTabName) {
      self.selectedNavTab = selectedNavTab
    },
    setDebug(value: boolean) {
      self.debug = value
    },
    toggleDebug() {
      self.debug = !self.debug
    },
    setChallenge(challenge: Challenge) {
      self.challenge = challenge
    },
  }))

export const circles = CirclesModel.create({})
